import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CapellaItemData } from '../../models/capella/capella-item.model';

interface CapellaState {
  loading: boolean;
  error: boolean;
  capellaData: CapellaItemData[];
  capellaPage: number;
}
export const INITIAL_CAPELLA_STATE: CapellaState = {
  loading: false,
  error: false,
  capellaData: [],
  capellaPage: 1,
};

const CapellaSlice = createSlice({
  name: 'capella',
  initialState: INITIAL_CAPELLA_STATE,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
    setCapellaData: (state, action: PayloadAction<CapellaItemData[]>) => {
      state.capellaData = action.payload;
    },
    setCapellaPage: (state, action: PayloadAction<number>) => {
      state.capellaPage = action.payload;
    },
  },
});

export const { setLoading, setError, setCapellaData, setCapellaPage } =
  CapellaSlice.actions;

export default CapellaSlice.reducer;
